import {GenericList} from './GenericList';
import {Role} from '../../models/Role';

export class RoleList extends GenericList<Role> {}
